import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment' // Pfad anpassen
import { FavoriteService } from '../../services/favorites.service';

import { ClrTextareaModule, ClrSpinnerModule } from '@clr/angular';


interface DialogMessageEvent {
  message: string;
}

@Component({
  selector: 'app-suggest',
  standalone: true,
  imports: [CommonModule, FormsModule, ClrTextareaModule, ClrSpinnerModule],
  templateUrl: './suggest.component.html',
  styleUrl: './suggest.component.css'
})
export class SuggestComponent implements OnInit {
  comment: string = '';
  slideBase64: string | null = null;

  isUploading: boolean = false;
  successMessage: string = '';
  errorMessage: string = '';

  constructor(
    private http: HttpClient,
    private favoriteService: FavoriteService
  ) { }

  ngOnInit() {

    Office.onReady(() => {
      Office.context.ui.addHandlerAsync(Office.EventType.DialogParentMessageReceived, (arg: DialogMessageEvent) => {
        const data = JSON.parse(arg.message);
        if (data.type === 'slide-data') {
          this.slideBase64 = data.content;
        }
      });

      Office.context.ui.messageParent(JSON.stringify({ type: 'ready-for-slide' }));
    });
  }

  async submitSuggestion() {
    if (!this.slideBase64) {
      this.errorMessage = 'Fehler: Folie wurde noch nicht geladen. Bitte kurz warten.';
      return;
    }

    this.isUploading = true;
    this.errorMessage = '';
    this.successMessage = '';

    try {
      const token = await this.favoriteService.getAccessTokenPromise();

      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      });

      const payload = {
        base64Data: this.slideBase64,
        comment: this.comment
      };

      await lastValueFrom(
        this.http.post(`${environment.appConfig.apiEndpoint}/submitSuggestion`, payload, { headers })
      );

      this.successMessage = 'Vorschlag erfolgreich gesendet! Fenster schließt sich...';

      setTimeout(() => {
        Office.context.ui.messageParent(JSON.stringify({ type: 'close-dialog' }));
      }, 2000);

    } catch (error) {
      console.error('Upload Error:', error);
      this.errorMessage = 'Fehler beim Hochladen. Bitte versuche es später noch einmal.';
    } finally {
      this.isUploading = false;
    }
  }
  cancel() {
    Office.context.ui.messageParent(JSON.stringify({ type: 'close-dialog' }));
  }
}
